import React from 'react';

interface Props {
  icon: string;
  title?: string;
  className?: string;
  onClick?: (e?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  style?: React.CSSProperties;
}

const Icon = (props: Props) => {
  const { icon } = props;

  return (
    <span
      data-icon={icon}
      {...props}
    />
  );
};

export default Icon;
